import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import userDetailsReducer from './userDetailsReducers';
import fetchTopLanesReducer from './marketInsights/topLanesReducers';
import fetchLanesReducer from './marketInsights/laneDetailsReducers';
import fetchLanesYearReducer from './marketInsights/laneDetailsYearReducers';
import laneSearchReducer from './marketInsights/laneSearchReducers';
import fetchSeasonalityReducer from './marketInsights/seasonalityReducers';
import fetchTopInboundAndOutboundLanesReducer from './marketInsights/topInboundAndOutboundLanesReducers';
import notificationReducer from './notificationReducers';
import rateCalculatorReducer from './marketInsights/rateCalculatorReducers';
import fetchNationalChartsReducer from './truckLoadRate/nationalReducers';
import fetchStateRateChartsReducer from './truckLoadRate/stateRateReducers';
import fetchLanesKeyPerformanceIndicatorsReducer from './networkInsights/lanesKeyPerformanceIndicatorsReducers';
import fetchTopNetworkLanesReducer from './networkInsights/topNetworkLanesReducers';
import fetchGeographyPolygon from './networkInsights/geographyPolygonReducers';
import fetchProcessRatesReducers from './truckLoadRate/processRatesReducers';
import manageUsersReducers from './truckLoadRate/admin/manageUsersReducers';
import accountReducer from './truckLoadRate/admin/accountReducers';
import fetchBillingHistoryReducers from './truckLoadRate/billingHistoryReducers';

import { EMPTY_STORE } from '../actions/index';
import subscriptionStatusReducer from './truckLoadRate/admin/subscriptionStatusReducers';

const appReducer = combineReducers({
    userDetails: userDetailsReducer,
    topLanesData: fetchTopLanesReducer,
    laneDetails: fetchLanesReducer,
    laneDetailsYearly: fetchLanesYearReducer,
    laneSearch: laneSearchReducer,
    seasonalityData: fetchSeasonalityReducer,
    notification: notificationReducer,
    topInboundAndOutboundLanesData: fetchTopInboundAndOutboundLanesReducer,
    rateCalculatorData: rateCalculatorReducer,
    nationalData: fetchNationalChartsReducer,
    stateRateData: fetchStateRateChartsReducer,
    lanesKeyPerformanceIndicatorsData: fetchLanesKeyPerformanceIndicatorsReducer,
    topNetworkLanesData: fetchTopNetworkLanesReducer,
    networkGeographyData: fetchGeographyPolygon,
    processRates: fetchProcessRatesReducers,
    manageUsers: manageUsersReducers,
    accountInfo: accountReducer,
    billingHistory: fetchBillingHistoryReducers,
    subscriptionDetails: subscriptionStatusReducer
});

const rootReducer = (state: any, action: any): object => {
    switch (action.type) {
        case EMPTY_STORE: {
            storage.removeItem('persist:root');
            return appReducer(undefined, action);
        }
        default:
            return appReducer(state, action);
    }
};

export default rootReducer;
